import React from "react";

import { bugsnag } from "~/libs/bugsnag";

const ErrorBoundary = bugsnag.getPlugin("react")!.createErrorBoundary(React);

export { ErrorBoundary };
